export default __webpack_public_path__ + "static/media/hemp.ed45dc76.webp";